import { IItem } from "../items";
import { AbstractDocumentAlert } from "./AbstractDocumentAlert";
import { IDocumentItemKey } from "../IDocumentItemKey";
import { IDocumentItemAlert } from "../IDocumentItemAlert";

export abstract class AbstractDocumentItemAlert<T extends IItem> extends AbstractDocumentAlert implements IDocumentItemAlert {
  constructor(private readonly _itemSetId: number, item: T, isError: boolean) {
    super(isError);
    this._detectedItem = item.clone() as T;
  }

  protected readonly _detectedItem: T;

  get detectedItem(): IItem {
    return this._detectedItem;
  }

  get itemKey(): IDocumentItemKey {
    return {
      setId: this._itemSetId,
      privateId: this.detectedItem.privateId,
    };
  }

  get itemSetId(): number {
    return this._itemSetId;
  }
}
